<template>
  <div style="margin: 0 auto; max-width: 800px;">
    <div class="mt-3 ml-3 mr-3">
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>
      <div v-if="$store.state.isUserLoggedIn">
        <h1 style="font-size: 22px;">Welcome back, {{$store.state.user.email}}!</h1>
      </div>

      <div v-if="$store.state.user.isAdmin">
        <p class="mt-1 text-left link mb-5" @click="admin">Admin Dashboard</p>
      </div>
      <p class="mt-1 text-left link" @click="changePasswordPage">Change Password</p>
      <p class="mt-1 text-left link" @click="logout">Logout</p>

      <p class="mt-5 text-left link" @click="addressBook">View Address Book</p>
      <p class="mt-3 text-left link" @click="orders">View Orders</p>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";

export default {
  data: () => ({
    error: "",
    user: ""
  }),
  async mounted() {
    this.scrollToTop();
    try {
      const response = await AuthenticationService.dashboard();
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    changePasswordPage() {
      this.$router.push("/change-password");
    },
    admin() {
      this.$router.push("/admin");
    },
    addressBook() {
      this.$router.push("/addressBook");
    },
    orders() {
      this.$router.push("/orders");
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
